import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { Button, Spacer, rem } from 'design-system';
export const WithdrawalTimesInfoModalContent = ({ hideModal, withdrawalInfo, }) => {
    const renderRow = useCallback((title, info, subTitle) => (<View style={styles.infoRow} key={title}>
        <View style={styles.titleView}>
          <Text Text-16>{title}</Text>
          {!!subTitle && (<Text TextThin-14 Secondary>
              {subTitle}
            </Text>)}
        </View>
        <Text Text-16>{info}</Text>
      </View>), []);
    return (<View>
      <Spacer h={16}/>
      {withdrawalInfo.infoArr.map((info) => renderRow(info.title, info.info, info.subTitle))}
      <Spacer h={16}/>
      <View style={styles.footer}>
        <View style={styles.footer}>
          <Text TextThin-14 Secondary centered>
            {withdrawalInfo.exampleString}
          </Text>
        </View>
        <Spacer h={16}/>
        <Button brand title="Close" onPress={hideModal}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    footer: {
        paddingHorizontal: rem(16),
    },
    infoRow: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    titleView: {
        flex: 1,
    },
});
